var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center"},[_c('h1',[_vm._v("\n      404\n  ")]),_c('h2',[_vm._v("\n      ❌ something went wrong ❌\n  ")])])
}]

export { render, staticRenderFns }